<tool-drawer-container (openFormDialog)="openDialog()">
  <ftic-course-dwf-apr-form class="form-slot"></ftic-course-dwf-apr-form>

  <tool-header
    class="tool-header"
    headerTitle="FTIC Course DWF & APR"
    subtitle="Identifies DWF for the top 25 most enrolled courses, APR rate by grade, and trends for the selected course."
  ></tool-header>

  <ftic-course-dwf-apr-content
    class="main-content"
  ></ftic-course-dwf-apr-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'FTIC Course DWF & APR'
      )
    "
  ></related-links>
</tool-drawer-container>
